import React from 'react';
import { CollectionOpenSearch } from '@europrocurement/l2d-domain';
import { ColumnDatatable } from '@europrocurement/flexy-datatable';
import { Box, Typography } from '@mui/material';
import { TooltipedIcon } from '@europrocurement/flexy-components';
import { demoIcon } from '@europrocurement/l2d-icons';
import { OrderStatus } from '../components';
import { OrderStatusProps } from '../components/liste/OrderStatus/OrderStatus';

const useOrderTable = () => {
    const columns: ColumnDatatable<CollectionOpenSearch>[] = [
        {
            label: 'Numéro',
            render: ({ numero, demo }) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    {demo && (
                        <TooltipedIcon
                            icon={demoIcon}
                            tooltip="Démo"
                            size="xs"
                            color="error"
                        />
                    )}
                    <Typography
                        variant="l2dtableCell"
                        color="text.gris70"
                    >
                        {numero}
                    </Typography>
                </Box>
            ),
            isDisplayed: true,
            sortable: true,
            field: 'numero',
            sx: {
                display: {
                    xs: 'none',
                    sm: 'none',
                    md: 'table-cell',
                    lg: 'table-cell',
                    xl: 'table-cell',
                },
            },
        },
        {
            label: 'Société',
            render: ({ clientLibelle }) => (
                <Typography
                    variant="l2dtableCell"
                    color="text.gris70"
                >
                    {clientLibelle}
                </Typography>
            ),
            isDisplayed: true,
            sortable: false,
            field: 'clientLibelle',
            sx: {
                display: {
                    xs: 'none',
                    sm: 'none',
                    md: 'table-cell',
                    lg: 'table-cell',
                    xl: 'table-cell',
                },
            },
        },
        {
            label: 'Facture',
            render: ({ statutInvoceLibelle }) => (
                <OrderStatus status={statutInvoceLibelle as OrderStatusProps['status']} />
            ),
            isDisplayed: true,
            sortable: false,
            field: 'statutInvoceLibelle',
            sx: {
                display: {
                    xs: 'none',
                    sm: 'none',
                    md: 'table-cell',
                    lg: 'table-cell',
                    xl: 'table-cell',
                },
            },
        },
        {
            label: 'Devis',
            render: ({ statutQuoteLibelle }) => (
                <OrderStatus status={statutQuoteLibelle as OrderStatusProps['status']} />
            ),
            isDisplayed: true,
            sortable: false,
            field: 'statutQuoteLibelle',
            sx: {
                display: {
                    xs: 'none',
                    sm: 'none',
                    md: 'table-cell',
                    lg: 'table-cell',
                    xl: 'table-cell',
                },
            },
        },
        {
            label: 'Etat facturabilité',
            render: ({ incompleteForBilling }) => (
                <>
                    {incompleteForBilling}
                    <OrderStatus
                        status={
                            incompleteForBilling ? 'INCOMPLETEFORBILLING' : 'COMPLETEFORBILLING'
                        }
                    />
                </>
            ),
            isDisplayed: true,
            sortable: false,
            field: 'incompleteForBilling',
            sx: {
                display: {
                    xs: 'none',
                    sm: 'none',
                    md: 'table-cell',
                    lg: 'table-cell',
                    xl: 'table-cell',
                },
            },
        },
        {
            label: 'Acompte attendu',
            render: ({ acompteAttendu }) => (
                <Typography
                    variant="l2dtableCell"
                    color="text.gris70"
                >
                    {acompteAttendu && Number(acompteAttendu) > 0
                        ? `${Number(acompteAttendu).toFixed(2)} €`
                        : '-'}
                </Typography>
            ),
            isDisplayed: true,
            sortable: false,
            field: 'acompteAttendu',
            sx: {
                display: {
                    xs: 'none',
                    sm: 'none',
                    md: 'table-cell',
                    lg: 'table-cell',
                    xl: 'table-cell',
                },
            },
        },
    ];

    return { columns };
};

export default useOrderTable;
